export * from "./banner";
export * from "./about";
export * from "./stories";
export * from "./projects";
export * from "./client";
export * from "./solution";
export * from "./sustain";
export * from "./why_choose_us";
export * from "./home-form";
export * from "./resource";
export * from "./space";
export * from "./waaree_stocks";